import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { LeadActions } from './lead.actions';
import { ILeadState } from './lead.state';

export const initialLeadState: ILeadState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const LeadReducerFn = createReducer(
  initialLeadState,
  on(LeadActions.reset, (state: ILeadState, action) => {
    return new StateBuilder<ILeadState>(initialLeadState).build();
  }),
  on(LeadActions.load, (state: ILeadState, action) => {
    return new StateBuilder<ILeadState>(state).toLoading().build();
  }),
  on(LeadActions.loadSuccess, (state: ILeadState, action) => {
    return new StateBuilder<ILeadState>(state, action).toLoaded().build();
  }),
  on(LeadActions.submit, (state: ILeadState, action) => {
    return new StateBuilder<ILeadState>(state, action).toLoading().build();
  }),
  on(LeadActions.submitSuccess, (state: ILeadState, action) => {
    return new StateBuilder<ILeadState>(state, action).toLoaded().build();
  })
);

export function leadReducer(state: ILeadState | undefined, action: Action) {
  return LeadReducerFn(state, action);
}
